import data from './dataSlice'
import state from './stateSlice'
const { combineReducers } = require("redux");

const reducer = combineReducers({
    data,
    state
})

export default reducer